<mat-card class="card" [class.selected-card]="selected">
    <div class="card-header" *ngIf="!hideHeader">
        <div mat-card-avatar>
            <a [routerLink]="routerLink" class="profile-link" aria-label="Open athlete profile" (click)="clickedClose()">
                <img *ngIf="headerImageUrl; else noLogo"
                    [src]="headerImageUrl"
                    class="profile-image"
                    [style.borderColor]="primaryColor"
                    (error)="onHeaderImageError($event)">
                <ng-template #noLogo>
                    <div class="profile-image portrait-text">
                        {{getDefaultText() | uppercase}}
                    </div>
                </ng-template>
            </a>
        </div>
        <div class="header-title-section">
            <a class='card-title profile-name-link' [routerLink]="routerLink" (click)="clickedClose()">{{headerName}}</a>
            <div class='card-sub-title' *ngIf="selected">
                <div><a [routerLink]="routerLink" (click)="clickedClose()">{{ isTeamOnlyHighlight() ? getNameForTitle() : (getNameForTitle() | titlecase) }}</a></div>
                <div>{{highlightDate | date:'M/d/yyyy'}} - {{getViewsForTitle()}}</div>
            </div>        
        </div>    
        <!-- <a [routerLink]="'/products'" target="_blank" *ngIf="selected && highlightRecord?.sportid !== 'football'">
          <button mat-flat-button color="primary">WE'LL BUILD YOUR HIGHLIGHT REEL</button>
        </a> -->
        <button mat-icon-button *ngIf="selected && !hideCloseButton" (click)="clickedClose()" aria-label="Close highlight">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="panel-body">
        <img
          *ngIf="thumbnailUrl && !selected"
          [src]="thumbnailUrl"
          class="panel-body-image"
          loading="lazy"
          decoding="async"> 
        <button *ngIf="!selected" class="play_button" (click)="clickedPlay()">
            <fa-icon class="play-icon" [icon]="['fas', 'play-circle']"></fa-icon>
        </button>
        <video 
          *ngIf="selected" 
          class="highlight-video" 
          src="{{highlightRecord.highlight.highlightlink}}" 
          controls autoplay 
          poster="{{thumbnailUrl}}"
					playsinline
					webkit-playsinline
          appVideo
          ></video>
    </div>
    <div class="selected-highlight-info" *ngIf="selected">
        <div class="selected-highlight-title">{{highlightTitle}}</div>
        <div class="selected-highlight-date">{{highlightDate | date:'mediumDate'}}</div>
    </div>
    <div class="landing-highlight-info" *ngIf="!selected">
        <div class="landing-highlight-title">{{highlightTitle}}</div>
        <div class="landing-highlight-date">{{highlightDate | date:'mediumDate'}}</div>
    </div>
    <mat-card-actions>
        <div class="action-groups">
            <div class="view-action-group">
                <span class="highlight-stat">
                    <mat-icon class="icon-font">visibility</mat-icon> {{highlightViews}}
                </span>
            </div>

            <div class="reaction-action-group">
                <button mat-button (click)="updateReactions('like', !lsReaction.like)" [ngClass]="{'like': lsReaction.like}" matTooltip="Like this highlight" class="left-button">
                    <mat-icon class="icon-font">thumb_up</mat-icon> {{getCountForReaction('like')}}
                </button>
                <button mat-button (click)="updateReactions('fire', !lsReaction.fire)" [ngClass]="{'fire': lsReaction.fire}" matTooltip="This highlight is on fire!" class="left-button">
                    <mat-icon class="icon-font">local_fire_department</mat-icon> {{getCountForReaction('fire')}}
                </button>
                <button mat-icon-button class="share-menu-button" aria-label="Share this highlight" [matMenuTriggerFor]="shareMenu" matTooltip="Share this highlight">
                    <mat-icon class="icon-font">share</mat-icon>
                </button>
                <mat-menu #shareMenu="matMenu" xPosition="before" yPosition="above" class="highlight-share-menu">
                    <button mat-menu-item (click)="downloadFile()">
                        <mat-icon>file_download</mat-icon>
                        <span>Download Video</span>
                    </button>
                    <button mat-menu-item (click)="copyHighlightLinkToClipboard(highlightRecord.highlight._id)">
                        <mat-icon>content_copy</mat-icon>
                        <span>Copy Link</span>
                    </button>
                    <a [href]="getMailLinkForHighlight()" target="_blank" class="highlight-menu-link">
                        <button mat-menu-item>
                            <mat-icon>mail_outline</mat-icon>
                            <span>Email Link</span>
                        </button>
                    </a>
                    <a [href]="getTwitterUrl()" target="_blank" class="highlight-menu-link">
                        <button mat-menu-item>
                            <fa-icon [icon]="['fab', 'x-twitter']" class="menu-fa-icon"></fa-icon>
                            <span>Share on X</span>
                        </button>
                    </a>
                    <button mat-menu-item (click)="shareToFacebook()">
                        <fa-icon [icon]="['fab', 'facebook']" class="menu-fa-icon"></fa-icon>
                        <span>Share on Facebook</span>
                    </button>
                </mat-menu>
            </div>
        </div>
    </mat-card-actions>
  </mat-card>
